export const  RecursosEnum  = Object.freeze({
    PRINCIPAL: 1,
    AYUDA_VISUAL: 2,
    DOCUMENTO: 3,
    REVISION: 4
})